import React from 'react';

const Pricing = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Preise für Unternehmer</h1>
      <p className="mb-4 text-slate-600 dark:text-slate-300">
        Unternehmer zahlen für das Einstellen von Leerfahrten:
      </p>

      <ul className="space-y-2 list-disc pl-6 text-slate-700 dark:text-slate-200">
        <li>Monatsabo: 29 € / Monat – unbegrenzte Einträge</li>
        <li>Pay-per-Lead: 3 € pro Kontaktaufnahme</li>
        <li>Freemium: 3 Gratis-Kontakte pro Monat</li>
      </ul>
    </div>
  );
};

export default Pricing;
